export default [
  'accounting2@foodforjoe.es',
  'teresa.sanchez@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
